export default __webpack_public_path__ + "static/imagem-form-m-6467ec9ecb032205fdfa7fea7aab48cd.png";